import {useMemo} from 'react';
import {
	useSingleFileUploadForm,
	type UseSingleFileUploadFormParams,
	type SingleFileUploadFormValues,
} from '@netx/core-upload-next/hooks/useSingleFileUploadForm';

export interface AssetCustomThumbnailUploadFormValues
	extends SingleFileUploadFormValues {
	assetId: number;
}

export interface UseAssetCustomThumbnailUploadFormParams
	extends Omit<
		UseSingleFileUploadFormParams<AssetCustomThumbnailUploadFormValues>,
		'defaultValues'
	> {
	assetId: number;
}

export const useAssetCustomThumbnailUploadForm = ({
	assetId,
	...props
}: UseAssetCustomThumbnailUploadFormParams) => {
	const defaultValues = useMemo(() => ({assetId}), [assetId]);
	return useSingleFileUploadForm<AssetCustomThumbnailUploadFormValues>({
		...props,
		defaultValues,
	});
};
